import SideMenu from '@/containers/side-menu/SideMenu.vue'
import ParkingMap from '@/pages/parking-map/ParkingMap'

export default {
  path: '/parking-map',
  name: 'ParkingMap',
  components: {
    mainContent: ParkingMap,
    mainMenu: SideMenu
  },
  meta: {
    role: {
      sectorId: 'parking-map'
    },
    breadcrumb: {
      title: 'Mapa dos Estacionamentos',
      paths: [
        { title: 'mapas' },
        { title: 'estacionamento' },
      ]
    }
  }
}